<template>
  <div>
    <div class="top">
      <TopContent />
    </div>
    <div class="product_bg"></div>
    <div class="product_con">
      <div class="proTit">
        <div class="tittext fontsize2">产品列表</div>
        <div class="blue"></div>
      </div>
      <div class="items-container">
        <div v-for="(item, index) in items" :key="index" class="item" @click="productPush(item.url)">
          <div class="image-container">
            <img :src="item.image" :alt="item.title" class="item-image">
          </div>
          <div class="title-container">
            <h3 class="item-title">{{ item.title }}</h3>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <BottomContent />
    </div>
  </div>
</template>
<script>
import TopContent from "@/components/Top/index.vue";
import BottomContent from "@/components/Bottom/index.vue";
export default {
  components: { TopContent, BottomContent },
  data () {
    return {
      items: [
        { image: require('../../assets/img/Product1.png'), title: '大数据推送系统', url: '/Product1s' },
        { image: require('../../assets/img/Product2.png'), title: '启秘健康大数据平台', url: '/Product2s' },
        { image: require('../../assets/img/Product3.png'), title: '医联体综合管理信息平台', url: '/Product3s' },
        { image: require('../../assets/img/Product4.png'), title: '学生精准健康教育及风控平台', url: '/Product4s' },
        { image: require('../../assets/img/Product5.png'), title: '超声在线', url: '/Product5s' },
        { image: require('../../assets/img/Product6.png'), title: '医疗精准扶贫', url: '/Product6s' },
        { image: require('../../assets/img/Product7.png'), title: '医院信息管理系统', url: '/Product7s' },
        { image: require('../../assets/img/Product8.png'), title: '影像云', url: '/Product8s' }
      ],
    }
  },
  computed: {
    isMobile () {
      return window.innerWidth <= 1439;
    },
  },
  mounted () {
    this.load();
  },
  methods: {
    productPush (url) {
      this.$router.push(url)
    },
    load () {
      if (document && document.body) {
        document.body.style.margin = '0px';
        this.originalBodyMargin = document.body.style.margin;
      }
    },
  },
}
</script>
<style lang="scss" src="../../assets/css/PC.scss" scoped></style>
<style lang="scss" scoped>
.bottom {
  height: 70px;
}

.product_bg {
  background-image: url("../../assets/img/Product_bg.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: 70vh;
}

.fontsize1 {
  font-size: 19px;
}

.fontsize2 {
  font-size: 24px;
}

.product {
  background-color: #F7F9FD;
}

.product_con {
  width: 70%;
  margin: 0px auto 50px auto;

  .proTit {
    height: 15vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .tittext {
      font-weight: bold;
    }

    .whiteFont {
      color: white;
    }

    .blue {
      background-color: #0073d3;
      width: 150px;
      height: 7px;
      margin: 15px 0px;
    }
  }

  .items-container {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    grid-template-rows: repeat(2, 1fr);
    gap: 25px;
    height: 100%;
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
  }

  .item {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    // border-radius: 5px;
    overflow: hidden;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }

  .image-container {
    flex: 1;
    overflow: hidden;
    width: 100%;
  }

  .item-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
  }

  .item:hover .item-image {
    transform: scale(1.05);
  }

  .title-container {
    background: white;
    padding: 10px 0px;
    text-align: center;
    width: 100%;
  }

  .item-title {
    margin: 0;
    color: black;
    font-size: 14px;
    font-weight: normal;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }
}

@media (max-width: 1439px) and (min-width: 10px) {
  .product_bg {
    height: 30vh;
  }

  .fontsize1 {
    font-size: 15px;
  }

  .fontsize2 {
    font-size: 15px;
  }

  .product_con {
    padding: 3vh;
    width: 90%;

    .proTit {
      height: auto;

      .blue {
        margin: 5px 0px 0px 0px;
        width: 80px;
        height: 5px;
      }
    }

    // height: 70vh;
    .items-container {
      margin-top: 15px;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      height: 90%;
      gap: 15px;
      padding: 0px;
    }
  }
}
</style>